// Shared guard: never let a tabs-UI action (Alt+Q switcher, LopTabBar
// activate/close) proceed while a modal dialog is open (plan §4 corner:
// "דיאלוגים ב-portal ... v1: הבר וה-switcher מתעלמים כשיש [role=dialog] פתוח").
//
// Every dialog in the app (LopSearchModal, LopGridCustomizationDialog,
// ValuationParamsModal, CalcDetailsModal, AddForwardInterestSettingModal,
// SpecialCreationLimitFormModal, AgendaDailyPage's inline confirm) renders
// `role="dialog"` on its outer container — a single selector covers every
// current and future dialog that follows the same convention.
//
// None of these dialogs are portalled to `document.body` — they render
// in-place inside their owning page's component tree, which lives inside a
// `.lop-tab-pane`. That already means a dialog open in tab A cannot end up
// floating visually over tab B: when TabHost hides A's pane
// (`visibility:hidden` + `inert`), the dialog — an ordinary DOM descendant —
// inherits `visibility:hidden` and becomes non-interactive via `inert` too,
// same as the rest of the pane. What's NOT handled for free is the
// INTERACTION side: without this guard, clicking another tab (or
// middle-clicking / closing a tab from the bar) while a dialog is open would
// still switch/close normally, silently leaving that dialog open-but-hidden
// in the backgrounded pane — surprising state to leave dangling. Simplest
// safe behavior: the tab bar no-ops (just like the switcher already did)
// whenever a dialog is open anywhere in the tree.
const DIALOG_SELECTOR = '[role="dialog"]';

export function isDialogOpen(): boolean {
  return document.querySelector(DIALOG_SELECTOR) !== null;
}
